import AxiosConfig from '../../../config/AxiosConfig';

const useSetMessageToSend = () => {
  const setMessageToSend = async (messageId) => {
    try {
      const response = await AxiosConfig.create(
        'put',
        `/messages/${messageId}/tosend`
      )
        .call()
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to set message to send:', err);
      throw new Error(`Message to send failed: ${err.message}`);
    }
  };

  return {
    setMessageToSend,
  };
};

export default useSetMessageToSend;
